var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.7676 0H2.62479C1.65247 0 .865773.675.865773 1.5l-.008839 9c0 .825.795536 1.5 1.767856 1.5H16.7676c.9724 0 1.7679-.675 1.7679-1.5v-9c0-.825-.7955-1.5-1.7679-1.5Zm0 3L9.69622 6.75 2.62479 3V1.5l7.07143 3.75L16.7676 1.5V3Z","fill":"currentColor"}));
}

Mail.defaultProps = {"width":"19","height":"12","viewBox":"0 0 19 12","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
